// extracted by mini-css-extract-plugin
module.exports = {"container":"Zc","hero":"_c","content":"ad","typeProd":"bd","notTransparent":"cd","sliderDots":"dd","active":"ed"};